// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1823":"f2dfa6fa62730e31","2226":"f1aef0ec1df1ba45","6487":"4d5ffdcb56ea7157","7102":"72adc30b1f79fcf3","7127":"06e1a6f4d276a0de","7650":"3a55f0846587f968","7887":"db3a1cfab8ab5a17"}[chunkId] + ".js";
};